import React from "react";

export function WrapTableWithDiv(node: React.ReactNode): React.ReactNode {
  if (!node) return null;

  if (typeof node === "string" || typeof node === "number") {
    return node;
  }

  if (Array.isArray(node)) {
    return node.map((child, i) => WrapTableWithDiv(child));
  }

  // 타입 가드: node가 ReactElement인지 검사
  if (React.isValidElement(node)) {
    // 타입 단언: node를 React.ReactElement로 간주
    const reactElement = node as React.ReactElement;

    if (reactElement.type === "table") {
      return (
        <div className="table-scroll-hint js-scrollable" key={reactElement.key || undefined}>
          {reactElement}
        </div>
      );
    }

    // children이 있을 수 있으므로 안전하게 접근
    const children = reactElement.props?.children
      ? WrapTableWithDiv(reactElement.props.children)
      : reactElement.props.children;

    return React.cloneElement(reactElement, { ...reactElement.props }, children);
  }

  return node;
}